import { RootState } from '@/models/root-state.model';
import { Modal } from '@/features/modal/types';

export const selectShowBalanceUpdate = (state: RootState): boolean => state.modal.showBalanceUpdate;

export const selectShowUserIsPepOrHioLogout = (state: RootState): boolean =>
  state.modal.showUserIsPepHioLogout;

export const selectIsFtdExitIntentShown = (state: RootState): boolean =>
  state.modal.showFtdExitIntent;

// New modal system selectors
export const selectModalIsOpen = (state: RootState): boolean => state.modal.isOpen;

export const selectModals = (state: RootState): Modal[] => state.modal.modals;
